import deburr from 'lodash/deburr';

export const deburrSearch = (search: string, target: string): boolean => {
  if (!target) return true;
  return deburr(search).toLowerCase().includes(deburr(target).toLowerCase());
};